import type { FaireProductEntity } from "../../entity_types/product";

export const p_9635xn788b: FaireProductEntity = {
  token: "p_9635xn788b",
  type: "product",
  name: "Trucker hat chains pearl trucker hat jewelry chain",
  brandToken: "b_a9hebqmabw",
  brandName: "ABLNco",
  imageUrl:
    "https://cdn.faire.com/fastly/edbefdee8ec40baeb667084e0f238da1562ed22267c8644edd76ab587112acef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7df912f60332c8b02044b8d77f54d69f0cd9af35c7dcf6db7829082aa500cdb7.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "chains are made with two clasps ends\n\nsize: to fit standard trucker hat sizing ",
  tags: [],
  msrpDollars: 19.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:00.815Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
